export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=408b920f01184dfe179f9df4f636e4a76aef318380&name=getProductServerAction!'